<div id="sidebar" class="sidebar px-0 pt-0 bg-white">
  <div>

    <div class="align-items-center">
      <a class="nav-link" routerLink="/dashboard">
          <img src="./assets/images/dashboard.svg" style="width: 1.1rem;" class="img-fluid me-2" />
          &nbsp;<label class="fw-semi-bold text-white">Dashboard</label>
        </a>
    </div>
    <ul class="nav flex-column" id="sidebar-nav">
      <li class="nav-item">
        <a class="nav-link">
        <img src="./assets/images/POS.svg" class="img-fluid me-2" style="width: 1.1rem;">
      <span class="text">Point of Sales</span>
      </a>
      </li>
      <li class="nav-item" *ngIf="allowRetail">
        <a class="nav-link" [class.active]="selectedMenu === '1'">
          <input class="form-check-input rdMenu" id="rdRetail" type="radio" name="sidebar-radio" value="1" [checked]="selectedMenu === '1'" (change)="onMenuChange('1')">
          <label class="text" for="rdRetail">Retail</label>
        </a>
      </li>
      <li class="nav-item" *ngIf="allowWholeSale">
        <a class="nav-link" [class.active]="selectedMenu === '2'">
          <input type="radio" id="rdWholesale" name="menu" value="2" class="form-check-input rdMenu"
            [checked]="selectedMenu === '2'" (change)="onMenuChange('2')" />
          <label class="text" for="rdWholesale">Wholesale</label>
        </a>
      </li>

      <li class="nav-item" *ngIf="allowShipped">
        <a class="nav-link" [class.active]="selectedMenu === '3'">
          <input type="radio" id="rdOnlineSale" name="menu" value="3" class="form-check-input rdMenu"
            [checked]="selectedMenu === '3'" (change)="onMenuChange('3')" />
          <label class="text" for="rdOnlineSale">Online Sale</label>
        </a>
      </li>

      <li class="nav-item" *ngIf="allowLayaway">
        <a class="nav-link" [class.active]="selectedMenu === '5'">
          <input type="radio" id="rdLayaway" name="menu" value="5" class="form-check-input rdMenu"
            [checked]="selectedMenu === '5'" (change)="onMenuChange('5')" />
          <label class="text" for="rdLayaway">Layaway</label>
        </a>
      </li>

      <li class="nav-item" *ngIf="allowPending">
        <a class="nav-link" [class.active]="selectedMenu === '6'">
          <input type="radio" id="rdPending" name="menu" value="6" class="form-check-input rdMenu"
            [checked]="selectedMenu === '6'" (change)="onMenuChange('6')" />
          <label class="text" for="rdPending">Pending</label>
        </a>
      </li>

      <li class="nav-item" *ngIf="allowReturn">
        <a class="nav-link" [class.active]="selectedMenu === '7'">
          <input type="radio" id="rdReturn" name="menu" value="7" class="form-check-input rdMenu"
            [checked]="selectedMenu === '7'" (change)="onMenuChange('7')" />
          <label class="text" for="rdReturn">Return</label>
        </a>
      </li>

      <li class="nav-item" *ngIf="allowVoid">
        <a class="nav-link" [class.active]="selectedMenu === '8'">
          <input type="radio" id="rdVoid" name="menu" value="8" class="form-check-input rdMenu"
            [checked]="selectedMenu === '8'" (change)="onMenuChange('8')" />
          <label class="text" for="rdVoid">Void</label>
        </a>
      </li>

      <li class="nav-item" *ngIf="allowRetail">
        <a class="nav-link" [class.active]="selectedMenu === 'gc'">
          <input type="radio" id="rdGiftCertificate" name="menu" value="gc" class="form-check-input rdMenu" 
          [checked]="selectedMenu === 'gc'" (change)="onMenuChange('gc')"/>
          <label class="text" for="rdGiftCertificate">Gift Certificate</label>
        </a>
      </li>

      <li class="nav-item" style="display: none;">
        <a class="nav-link rdOldLayaways">
          <input type="radio" id="rdOldLayaways" name="menu" class="form-check-input rdMenu" />
          <label class="text" for="rdOldLayaways">Old Layaways</label>
        </a>
      </li>
    </ul>
  </div>
</div>